import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lab" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "History control lab", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "View A", -1)
const _hoisted_4 = { style: {"margin-left":"auto","margin-right":"auto","width":"200px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "View B", -1)

import EffortLineControl from '@/components/Workspaces/persons/_spec/EffortTimelineComponent.vue'
// import SunriseEffort from '@/components/Workspaces/persons/_spec/EffortLogComponent.vue'
import { reactive } from 'vue';

import config from '@/_dev/config'
import {context_workspace} from '@/_dev/config'
import { Sunrise } from '@/logic/_infra/time'; 
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';



export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryLabComponent',
  setup(__props) {


const model:{reports:SunriseReportRmodel[]} = reactive({reports:[]})

setup()

async function  setup() : Promise<void> {

    const context = await context_workspace()

    const date = new Date('2023-05-18') //temporary date;

    const sunrise = Sunrise.DateAsSunrise(date)

    const dto = await context.service.personEfforts(config.person, sunrise)

    console.log(dto)

    if (context.cursor.person != null){

        const m = SunriseReportRmodel.Instance(context.cursor.person, dto.period, dto, context)

        model.reports.length = 0;

        model.reports.push(m)
        
        //const reports_buffer = personSunriseReports(context, context.cursor.person, dto, '',0)

        //reports_buffer.forEach(r => model.reports.push(r))
    }
    else console.error('Person is not available in context')

    console.log(context.cursor.workspace?.wid ?? 'N/A')
}


return (_ctx: any,_cache: any) => {
  const _component_SunriseEffort = _resolveComponent("SunriseEffort")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SunriseEffort, {
        header: null,
        reports: model.reports,
        "renewal-if": false
      }, null, 8, ["reports"])
    ]),
    _hoisted_5
  ]))
}
}

})